import React from "react";
import PropTypes from "prop-types";
import Dropzone from 'react-dropzone';
import classnames from "classnames";


export default class PictureUpload extends React.Component {

    static defaultProps = {
        onChange            : () => {},
        onVerifyFile        : () => true,
        onError             : () => {},
        multiple            : false,
        dropStyle           : {
            width: 100,
            height: 100,
            borderWidth: 1,
            borderColor: '#666',
            borderStyle: 'dashed',
            position: 'relative',
            textAlign: 'center',
            maxWidth: '100%'
        }
    };

    static propTypes = {
        onChange            : PropTypes.func,
        onVerifyFile        : PropTypes.func,
        onError             : PropTypes.func,
        dropStyle           : PropTypes.object,
        multiple            : PropTypes.bool,
        className           : PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    onReceiveFile = (files) => {
        files.forEach((file)=> {
            this._verifyAndUpload(file);
        });
    };

    _verifyAndUpload(file){
        var url = URL.createObjectURL(file);
        var img = new Image;

        img.onload = () => {
            if(this.props.onVerifyFile(file, img))
                this._uploadPicture(file)
        };
        img.onerror = () => {
            this.props.onError();
        };
        img.src = url;
    }

    _readPicture = (readCallback) => {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject();
            readCallback(reader);
        });
    };

    _uploadPicture(file){
        let blobPromise = this._readPicture( (reader) => reader.readAsArrayBuffer(file) );
        let dataUrlPromise = this._readPicture( (reader) => reader.readAsDataURL(file) );

        Promise.all([blobPromise, dataUrlPromise])
            .then((results) =>  this.props.onChange(...results) )
            .catch( () => this.props.onError() );
    }

    render = () => (
        <div className={classnames("picture-upload", this.props.className)}>
            <Dropzone style={this.props.dropStyle} onDrop={this.onReceiveFile} multiple={this.props.multiple} accept="image/*">
                { this.props.children }
            </Dropzone>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/picture-upload-crop/PictureUpload.jsx